var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.loading)?_c('div',{attrs:{"id":"spinner"}},[_c('flower-spinner',{attrs:{"animation-duration":2500,"size":70,"color":"#FFF"}})],1):_c('Wish')],1)}
var staticRenderFns = []

export { render, staticRenderFns }